import { Block, ParagraphXSmall, useStyletron } from "@mezo-org/mezo-clay"

import { IS_MEZO_MAINNET } from "#/shared/constants"
import { SwitchMezoNetworkButton } from "#/ui/Button"

import SidebarNavigationMatsnet from "./SidebarNavigationMatsnet"

export default function SidebarNavigationMezoChainInfo() {
  const [css, theme] = useStyletron()

  if (!IS_MEZO_MAINNET) return <SidebarNavigationMatsnet />

  return (
    <Block
      className={css({
        padding: theme.sizing.scale500,
        backgroundColor: theme.colors.backgroundSecondary,
        borderRadius: theme.borders.radius400,
      })}
    >
      <ParagraphXSmall>
        Looking for {IS_MEZO_MAINNET ? "Testnet" : "Mainnet"}? Go
      </ParagraphXSmall>
      <ParagraphXSmall marginBottom={theme.sizing.scale600}>
        here.
      </ParagraphXSmall>
      <SwitchMezoNetworkButton />
    </Block>
  )
}
